(function(window) { var svs = window.svs || {}; svs.modules = svs.modules || []; if(svs.modules.indexOf('/components/tipsen/route-result/assets/javascripts/use-selected-result-draw.js') >= 0) return;  svs.modules.push('/components/tipsen/route-result/assets/javascripts/use-selected-result-draw.js');
"use strict";

const {
  useEffect,
  useState
} = React;
const useQueryParam = svs.components.lbUtils.useQueryParam;
const {
  resolveProductId
} = svs.utils.products;
const useSelectedResultDraw = draws => {
  var _draws$, _draws$2;
  const [selectedDrawNumber, setSelectedDrawNumber] = useState((_draws$ = draws[0]) === null || _draws$ === void 0 ? void 0 : _draws$.drawNumber);
  const [selectedProductId, setSelectedProductId] = useState(resolveProductId((_draws$2 = draws[0]) === null || _draws$2 === void 0 ? void 0 : _draws$2.product));
  const drawNumberParam = useQueryParam('draw');
  const productIdParam = useQueryParam('product');
  useEffect(() => {
    if (drawNumberParam) {
      setSelectedDrawNumber(parseInt(drawNumberParam, 10));
    } else {
      setSelectedDrawNumber(draws.length ? draws[0].drawNumber : null);
    }
    if (productIdParam) {
      setSelectedProductId(parseInt(productIdParam, 10));
    } else {
      var _draws$3, _draws$4;
      setSelectedProductId(draws.length && (_draws$3 = draws[0]) !== null && _draws$3 !== void 0 && _draws$3.productId ? (_draws$4 = draws[0]) === null || _draws$4 === void 0 ? void 0 : _draws$4.productId : null);
    }
  }, [drawNumberParam, productIdParam, draws]);
  return [selectedDrawNumber, selectedProductId];
};
setGlobal('svs.components.tipsen.routeResult.useSelectedResultDraw', useSelectedResultDraw);

 })(window);